import { Icon, List } from "components";
import { JOB_TYPES } from "@/lib/constants";
import { Tooltip, TooltipContent, TooltipTrigger } from "ui/components/tooltip";
import JobNameCell from "@/components/cells/jobs/name-cell";
import JobFilters from "./filters";
import React from "react";
import { DateCell } from "@/modules/work/billables/cells";
import { EmployeeCell } from "components/cell/employee/cell";
import { StatusCell } from "@/components/status/cell";
import { getEmployeeFields } from "components/user/config";

const customSearch = (search) => ({
  _or: [
    { name: { _icontains: search } },
    { type: { _icontains: search } },
    { project: { name: { _icontains: search } } },
  ],
});

export default function Jobs({
  defaultFilters = {},
  storageKey = "jobs",
  title = "Jobs",
}) {
  const fields = [
    "id",
    "name",
    "status",
    "type",
    "project.project_id",
    "project.name",
    getEmployeeFields("coordinator"),
    "start_date",
    "end_date",
    "flag",
  ];
  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name", // this points to the data property
      sortable: true,
      cell: JobNameCell,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: ({ getValue }) => {
        const type = JOB_TYPES[getValue()];
        if (!type) return null;
        return (
          <Tooltip>
            <TooltipTrigger>
              <Icon icon={type.icon} className="text-muted-foreground size-4" />
            </TooltipTrigger>
            <TooltipContent>{type.label}</TooltipContent>
          </Tooltip>
        );
      },
      sortable: false,
    },
    {
      id: "project.name",
      header: "Project",
      accessorKey: "project.name",
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "coordinator",
      header: "JC",
      accessorKey: "coordinator",
      cell: EmployeeCell,
    },
    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "end_date",
      header: "End Date",
      accessorKey: "end_date",
      sortable: true,
      cell: DateCell,
    },
  ];

  // const deep = {
  //   timesheet: {
  //     _limit: -1,
  //   },
  //   extensions: {
  //     _sort: ["-date_created"],
  //   },
  // };
  const filters = {
    status: {
      _nin: ["archived", "closed", "cancelled"],
    },
    ...defaultFilters,
  };

  return (
    <List
      title={title}
      storageKey={storageKey}
      endPoint="jobs"
      filters={filters}
      columns={columns}
      meta={{ fields, customSearch }}
      sortBy="start_date"
      href={(item) => `/work/jobs/${item.id}`}
      renderFilters={JobFilters}
    />
  );
}
